module.exports = __webpack_public_path__ + "img/flag_en.ab291a3f.png";